/**
 * 法人向けサービスレベル検索: ランク別日付表示モード（端末内保存）
 */

export type CorporationRankDisplayMode = 'both' | 'e_only' | 'fg_only'

export const CORPORATION_RANK_DISPLAY_MODE_STORAGE_KEY =
  'yhc:serviceLevel:corporationRankDisplayMode'

export const FG_RANK_UNAVAILABLE_NOTE_LONG = '※FGランクは利用できないエリアです'
export const FG_RANK_UNAVAILABLE_NOTE_SHORT = '※利用不可エリアです'

const VALID_MODES: CorporationRankDisplayMode[] = ['both', 'e_only', 'fg_only']

function isValidMode(x: unknown): x is CorporationRankDisplayMode {
  return typeof x === 'string' && (VALID_MODES as string[]).includes(x)
}

export function loadCorporationRankDisplayMode(): CorporationRankDisplayMode {
  try {
    const raw = localStorage.getItem(CORPORATION_RANK_DISPLAY_MODE_STORAGE_KEY)
    if (isValidMode(raw)) return raw
  } catch {
    // プライベートモード等
  }
  return 'both'
}

export function saveCorporationRankDisplayMode(mode: CorporationRankDisplayMode): void {
  if (!isValidMode(mode)) return
  try {
    localStorage.setItem(CORPORATION_RANK_DISPLAY_MODE_STORAGE_KEY, mode)
  } catch {
    // 容量超過・ストレージ拒否等
  }
}

/** 法人向けでない画面では常に both として扱う */
export function resolveEffectiveRankDisplayMode(
  mode: CorporationRankDisplayMode,
  isCorporationView: boolean,
): CorporationRankDisplayMode {
  return isCorporationView ? mode : 'both'
}

export function fgRankUnavailableNoteText(
  effectiveMode: CorporationRankDisplayMode,
): string {
  return effectiveMode === 'fg_only'
    ? FG_RANK_UNAVAILABLE_NOTE_SHORT
    : FG_RANK_UNAVAILABLE_NOTE_LONG
}
